const handAnimationObject = {
    configName: 'hand',
    container: null,
    raveContainer: null,
    status: -1,
    frames: [],
    canvas: null,
    context: null,
    currentFrame: null,
    middleFrame: 100,
    countAnim1: 100,
    countAnim2: 35, //50
    plxElement: null,
    startAnim1: null,
    endAnim1: null,
    startAnim2: null,
    endAnim2: null,
    startLeftOffset: null,
    textContainer: null,
    parallaxFriction: .05,
    iframe: null,
    iframeSrc: null,
    initialize: function () {
        if (this.status < 0) {
            this.status = 0;

            this.container = document.querySelector('.hand-animation');
            this.raveContainer = document.querySelector('.rive-hand');
            this.canvas = document.getElementById('hand-animation__canvas');
            this.context = this.canvas.getContext("2d");
            this.plxElement = document.querySelector('.hand-animation__parallax');
            this.textContainer = document.querySelector('.finance-graphic__container');
            this.iframe = document.querySelector('.iframe-graphic iframe');
            this.iframeSrc = this.iframe.dataset.src;
            this.iframe.src = this.iframeSrc;
            this.reactToResize();

            for (let i = 1; i <= 135; i++) { //150
                this.frames[i] = null;
                const img = new Image();
                img.src = `${document.location.origin}/i/instaforex/images/hand_full/${i.toString().padStart(4, '0')}.jpg`;
                img.onload = () => {
                    main.setLoaderPercent(1);
                    this.frames[i] = img;
                    this.checkStatusLoad();
                }
            }
        }
    },
    checkStatusLoad: function () {
        let isAllLoad = true;
        Object.keys(this.frames).forEach((id) => {
            if (this.frames[id] === null) isAllLoad = false;
        });

        if (isAllLoad) {
            this.canvas.width = this.frames[1].width;
            this.canvas.height = this.frames[1].height;
            this.status = 1;
            main.setLoaderPercent(1);
        }

    },
    easeFunction: new CubicBezier(.06,.22,1,-0.27),
    easeFunctionMoveLeft: new CubicBezier(.08, .82, .82, 1),
    reactToScroll: function (data) {
        if (data.localOffset >= this.startAnim1 && data.localOffset <= this.endAnim1) {
            riveHandObject.pause();
            const scrollFraction = data.localOffset / (this.endAnim1 - this.startAnim1);
            const frameIndex = Math.min(
                this.countAnim1 - 1,
                Math.ceil(scrollFraction * this.countAnim1)
            );

            this.updateImage(frameIndex + 1);
        }

        if (
            (data.direction === 1 && data.localOffset > this.endAnim1 && data.localOffset < this.startAnim2) ||
            (data.direction === -1 && data.localOffset < this.startAnim2 && data.localOffset > this.endAnim1)
        ) {
            this.updateImage(this.middleFrame);
            this.canvas.parentElement.style.transform = '';
            riveHandObject.play();
        }

        if (data.localOffset >= this.startAnim2 && data.localOffset <= this.endAnim2) {
            riveHandObject.pause();
            const scrollFraction = (data.localOffset - this.startAnim2) / (this.endAnim2 - this.startAnim2);
            const frameIndex = Math.min(
                this.countAnim2 - 1,
                Math.ceil(scrollFraction * this.countAnim2)
            );

            this.updateImage(frameIndex + 1 + this.countAnim1);
        }

        if (window.innerWidth > 767 && data.localOffset >= this.startLeftOffset && data.localOffset <= this.endAnim2) {
            const height = (this.endAnim2 - this.startLeftOffset) * .8;
            const scroll = data.localOffset - this.startLeftOffset;
            const x = scroll / height;

            if (x <= 1) {
                let calcScroll = (this.canvas.clientWidth * .27) * this.easeFunctionMoveLeft(x);

                this.canvas.parentElement.style.transform = 'translate3d(' + Math.round(this.canvas.clientWidth * .77 - calcScroll) + 'px, 0, 0)';
            }
        }

        if (data.localOffset > this.endAnim2) {
            this.canvas.parentElement.style.transform = 'translate3d(50%, 0, 0)';
            this.updateImage(this.countAnim1 + this.countAnim2);
            this.container.classList.add('_show-labels');
            const height = (data.end - data.start) - this.endAnim2;
            const scroll = data.localOffset - this.endAnim2;
            const x = scroll / height;
            let calcScroll = height * this.easeFunction(x);

            this.container.style.transform = 'translate3d(0, ' + -calcScroll + 'px, 0)';
        } else {
            this.container.classList.remove('_show-labels');
            this.container.style.transform = '';
            this.plxElement.style.transform = '';
        }
    },
    setParallaxOffset: function (scroll) {
        scroll = scroll * this.parallaxFriction;
        if (scroll < 0) scroll = 0;
        if (scroll > 60) scroll = 60;

        this.textContainer.style.transform = 'translate3d(0, ' + (-scroll) + 'px, 0)';
    },
    updateImage: function (id) {
        if (this.currentFrame !== id) {
            this.currentFrame = id;
            this.context.drawImage(this.frames[id], 0, 0);
        }
    },
    reactToResize: function () {
        const config = main.detectScroll.getConfig(this.configName);

        this.startAnim1 = 0;
        this.endAnim1 = config.height * .11;
        this.endAnim2 = this.endAnim1 + promoTextObject.point * promoTextObject.elements.length;
        this.startAnim2 = this.endAnim2 - config.height * .11;
        this.startLeftOffset = this.endAnim2 - config.height * .05;

        this.container.classList.remove('_show-labels');
        this.container.style.transform = '';
        this.textContainer.style.transform = '';
        this.canvas.parentElement.style.transform = '';

        if (window.innerWidth < main.mobileResolutionBorder) {
            this.iframe.src = '';
        } else {
            if (this.iframe.src !== this.iframeSrc) this.iframe.src = this.iframeSrc;
        }
    }
};
